export enum RequestState {
  Failed = 'FAILED',
  Initial = 'INITIAL',
  InProgress = 'IN_PROGRESS',
  Succeeded = 'SUCCEEDED',
}
